// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import HoverMRRDescription from './HoverMRRDescription'
// JS Imports
// @ts-ignore
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function AdditionalJobPostingsRow() {
   const state = useQuoteContext()
   const permissionsShowMRROnDifferenceQuotes =
      state.featurePermissions['ShowMRROnDifferenceQuotes']
   const ShowMRROnDifferenceQuotes =
      permissionsShowMRROnDifferenceQuotes.includes(state.user_role)

   if (state.product_list['addJobPosting']?.NotInPricebook) {
      return <> </>
   }

   if (state.user_role != 'Partner')
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {state.product_list['addJobPosting']['ProductName']} (10/
               {formatFloatAsCurrencySymbol(
                  state.product_list['addJobPosting']['EmpListPrice'] * 10,
                  state.currencyObject,
               )}
               )
            </div>
            <div className='col-bhr2'>
               <input
                  className='form-control'
                  type='number'
                  step='10'
                  value={
                     state.productAdditionalJobsCount <= 0
                        ? ''
                        : state.productAdditionalJobsCount.toString()
                  }
                  onChange={(e) =>
                     state.onProductAdditionalJobsCountChange(
                        Number(e.target.value),
                     )
                  }
                  onBlur={() =>
                     state.onProductAdditionalJobsCountChange(
                        10 * Math.ceil(state.productAdditionalJobsCount / 10),
                     )
                  }
                  min={0}
                  placeholder={'0'}
               />
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.AdditionalJobsCosts.totalPrice,
                  state.currencyObject,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col col-bhr-blue'>
                     {formatFloatAsCurrencySymbol(
                        state.AdditionalJobsCosts.previousTotalPrice || 0,
                        state.currencyObject,
                     )}
                  </div>
                  {ShowMRROnDifferenceQuotes ? (
                     <HoverMRRDescription
                        listMRRTotal={state.AdditionalJobsCosts.listMRRTotal}
                        previousMRRTotal={
                           state.AdditionalJobsCosts.previousMRRTotal
                        }
                        MRRTotal={state.AdditionalJobsCosts.MRRTotal}
                        MRRTotalUSD={state.AdditionalJobsCosts.MRRTotalUSD}
                        currencyObjectCurrent={state.currencyObject}
                        currencyObjectUSD={state.currencyObjectUSD}
                     >
                        <span className={'hoverable'}>
                           {formatFloatAsCurrencySymbol(
                              state.AdditionalJobsCosts.totalPriceDifference ||
                                 0,
                              state.currencyObject,
                           )}
                        </span>
                     </HoverMRRDescription>
                  ) : (
                     <div className='col'>
                        {formatFloatAsCurrencySymbol(
                           state.AdditionalJobsCosts.totalPriceDifference || 0,
                           state.currencyObject,
                        )}
                     </div>
                  )}
                  {process.env.REACT_APP_ENVIRONMENT == 'staging' && (
                     <div className='col'>
                        {formatFloatAsCurrencySymbol(
                           state.AdditionalJobsCosts.MRRTotal || 0,
                           state.currencyObject,
                        )}
                     </div>
                  )}
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
